import script from "./AppFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppFooter.vue?vue&type=script&lang=ts&setup=true"

import "./AppFooter.vue?vue&type=style&index=0&id=7c5cfdf0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c5cfdf0"]])

export default __exports__